import React from 'react';

const SearchTextfeild = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M14.0801 14.1002L16.6468 16.6668M15.8359 9.5835C15.8359 11.2411 15.1775 12.8308 14.0054 14.0029C12.8333 15.175 11.2435 15.8335 9.58594 15.8335C7.92833 15.8335 6.33862 15.175 5.16652 14.0029C3.99442 12.8308 3.33594 11.2411 3.33594 9.5835C3.33594 7.92589 3.99442 6.33618 5.16652 5.16408C6.33862 3.99198 7.92833 3.3335 9.58594 3.3335C11.2435 3.3335 12.8333 3.99198 14.0054 5.16408C15.1775 6.33618 15.8359 7.92589 15.8359 9.5835Z"
                stroke="#6E6E6E"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default SearchTextfeild;
